import { render, staticRenderFns } from "./OsAdminTrialBanner.vue?vue&type=template&id=18e5cb0b&scoped=true"
import script from "./OsAdminTrialBanner.vue?vue&type=script&lang=ts"
export * from "./OsAdminTrialBanner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e5cb0b",
  null
  
)

export default component.exports